import React from 'react';
import { PageHeader } from '../components/common/PageHeader';
export function More() {
  return <div className="bg-slate-50 min-h-screen pb-20 flex flex-col" data-id="element-517">
      <PageHeader title="更多功能" data-id="element-518" />
      <div className="flex-1 flex items-center justify-center text-slate-400" data-id="element-519">
        <div className="text-sm" data-id="element-520">更多功能开发中...</div>
      </div>
    </div>;
}